import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { makeStyles } from '@material-ui/styles'
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@material-ui/core'

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'

import { numberFormat, dateFormat } from 'helpers'

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  actions: {
    justifyContent: 'flex-end'
  },
  acceptButton: {
    color: '#4caf50'
  },
  rejectButton: {
    color: '#f44336'
  },
  chipPending: {
    backgroundColor: '#fff3e0',
    color: '#e65100',
    fontWeight: 600,
    fontSize: 12
  },
  chipAccepted: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    fontWeight: 600,
    fontSize: 12
  },
  chipRejected: {
    backgroundColor: '#fce4ec',
    color: '#b71c1c',
    fontWeight: 600,
    fontSize: 12
  }
}))

const statusLabel = (status) => {
  if (status === 0) return { label: 'Menunggu', class: 'chipPending' }
  if (status === 1) return { label: 'Diterima', class: 'chipAccepted' }
  if (status === 2) return { label: 'Ditolak', class: 'chipRejected' }
  return { label: '-', class: 'chipPending' }
}

const ExTable = props => {
  const {
    className,
    withdrawals,
    page,
    pages,
    limit,
    onChangePage,
    onChangeRowsPerPage,
    onAccept,
    onReject,
    ...rest
  } = props

  const classes = useStyles()

  const [confirmDialog, setConfirmDialog] = useState({ open: false, type: null, id: null })

  const handleOpenConfirm = (type, id) => {
    setConfirmDialog({ open: true, type, id })
  }

  const handleCloseConfirm = () => {
    setConfirmDialog({ open: false, type: null, id: null })
  }

  const handleConfirm = () => {
    if (confirmDialog.type === 'accept') {
      onAccept(confirmDialog.id)
    } else if (confirmDialog.type === 'reject') {
      onReject(confirmDialog.id)
    }
    handleCloseConfirm()
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>No</TableCell>
                  <TableCell>Nama Pengguna</TableCell>
                  <TableCell>Bank</TableCell>
                  <TableCell>No. Rekening</TableCell>
                  <TableCell>Jumlah</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Tanggal</TableCell>
                  <TableCell align="center">Aksi</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {withdrawals.map((item, index) => {
                  const st = statusLabel(item.status)
                  return (
                    <TableRow
                      hover
                      key={item.id}
                    >
                      <TableCell>{((page * limit) - limit) + (index + 1)}</TableCell>
                      <TableCell>{item.user ? item.user.name : '-'}</TableCell>
                      <TableCell>{item.account_bank ? item.account_bank.bank_name : '-'}</TableCell>
                      <TableCell>{item.account_bank ? item.account_bank.account_number : '-'}</TableCell>
                      <TableCell>{numberFormat(item.amount, 'Rp. ')}</TableCell>
                      <TableCell>
                        <Chip
                          label={st.label}
                          className={classes[st.class]}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>{dateFormat(item.created_at)}</TableCell>
                      <TableCell align="center">
                        {item.status === 0 ? (
                          <>
                            <IconButton
                              className={classes.acceptButton}
                              onClick={() => handleOpenConfirm('accept', item.id)}
                              title="Terima"
                              size="small"
                            >
                              <CheckCircleOutlineIcon />
                            </IconButton>
                            <IconButton
                              className={classes.rejectButton}
                              onClick={() => handleOpenConfirm('reject', item.id)}
                              title="Tolak"
                              size="small"
                            >
                              <CancelOutlinedIcon />
                            </IconButton>
                          </>
                        ) : (
                          <span style={{ color: '#9e9e9e', fontSize: 13 }}>—</span>
                        )}
                      </TableCell>
                    </TableRow>
                  )
                })}
                {withdrawals.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={8} align="center" style={{ padding: 32, color: '#9e9e9e' }}>
                      Belum ada data penarikan komisi.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={pages * limit}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={handleCloseConfirm}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          {confirmDialog.type === 'accept' ? 'Terima Penarikan' : 'Tolak Penarikan'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmDialog.type === 'accept'
              ? 'Apakah Anda yakin ingin menerima pengajuan penarikan komisi ini?'
              : 'Apakah Anda yakin ingin menolak pengajuan penarikan komisi ini?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} color="default">
            Batal
          </Button>
          <Button
            onClick={handleConfirm}
            color={confirmDialog.type === 'accept' ? 'primary' : 'secondary'}
            variant="contained"
            autoFocus
          >
            {confirmDialog.type === 'accept' ? 'Terima' : 'Tolak'}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  )
}

ExTable.propTypes = {
  className: PropTypes.string,
  withdrawals: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
}

export default ExTable
